import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type AlertEvent = {
  __typename?: 'AlertEvent';
  acknowledgedAt?: Maybe<Scalars['Date']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  firedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  metricValue?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

export type AlertRule = {
  __typename?: 'AlertRule';
  enabled?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  ruleType?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
  windowMinutes?: Maybe<Scalars['Int']['output']>;
};

export type BootstrapResult = {
  __typename?: 'BootstrapResult';
  edgeConfig?: Maybe<Scalars['JSON']['output']>;
  edgeConfigRevision?: Maybe<Scalars['Int']['output']>;
  edgeTls?: Maybe<EdgeTlsMaterial>;
  edgeTlsRefreshPending?: Maybe<Scalars['Boolean']['output']>;
  secrets?: Maybe<Scalars['JSON']['output']>;
};

export type CheckoutResult = {
  __typename?: 'CheckoutResult';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  syncSubId?: Maybe<Scalars['String']['output']>;
  upgraded?: Maybe<Scalars['Boolean']['output']>;
};

export type EdgeTlsMaterial = {
  __typename?: 'EdgeTlsMaterial';
  certPem?: Maybe<Scalars['String']['output']>;
  keyPem?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

export type Execution = {
  __typename?: 'Execution';
  completedAt?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  entry?: Maybe<Scalars['String']['output']>;
  error?: Maybe<ExecutionError>;
  eventCount?: Maybe<Scalars['Int']['output']>;
  executionId?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  parentRequestId?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<ExecutionPreview>;
  projectId?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type ExecutionError = {
  __typename?: 'ExecutionError';
  message?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
};

export type ExecutionPreview = {
  __typename?: 'ExecutionPreview';
  kind?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type GlobalStats = {
  __typename?: 'GlobalStats';
  activeEdges?: Maybe<Scalars['Int']['output']>;
  activeProjects?: Maybe<Scalars['Int']['output']>;
  deadEdges?: Maybe<Scalars['Int']['output']>;
  degradedEdges?: Maybe<Scalars['Int']['output']>;
  totalEdges?: Maybe<Scalars['Int']['output']>;
};

export type MetricsResult = {
  __typename?: 'MetricsResult';
  evaluated?: Maybe<Scalars['Int']['output']>;
  fired?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeAlert?: Maybe<AlertEvent>;
  billingPortalUrl?: Maybe<Scalars['String']['output']>;
  checkout?: Maybe<CheckoutResult>;
  createAlertRule?: Maybe<AlertRule>;
  createOrganization?: Maybe<Organization>;
  createProject?: Maybe<Project>;
  createVerification?: Maybe<Verification>;
  deleteAlertRule?: Maybe<Scalars['Boolean']['output']>;
  deleteOrganization?: Maybe<Scalars['Boolean']['output']>;
  deleteTestCase?: Maybe<Scalars['Boolean']['output']>;
  ensurePersonalOrganization?: Maybe<Organization>;
  insertRevocation?: Maybe<Scalars['Boolean']['output']>;
  processBillingWebhook?: Maybe<WebhookResult>;
  processExecutionMetrics?: Maybe<MetricsResult>;
  removeOrgMember?: Maybe<Scalars['Boolean']['output']>;
  removeProjectMember?: Maybe<Scalars['Boolean']['output']>;
  rotateProjectSecret?: Maybe<Project>;
  setEdgeSyncConfig?: Maybe<SetEdgeSyncConfigResult>;
  setEdgeTls?: Maybe<SetEdgeTlsResult>;
  softDeleteProject?: Maybe<Scalars['Boolean']['output']>;
  syncSubscription?: Maybe<SubscriptionResult>;
  updateOrgMemberRole?: Maybe<OrgMember>;
  updateOrganization?: Maybe<Organization>;
  updateProject?: Maybe<Project>;
  updateProjectAgentUrl?: Maybe<Project>;
  updateTestCase?: Maybe<TestCase>;
  updateTestCaseStatus?: Maybe<Scalars['Boolean']['output']>;
  upsertOrgMember?: Maybe<OrgMember>;
  upsertProjectMember?: Maybe<ProjectMember>;
  upsertTestCase?: Maybe<TestCase>;
  upsertUser?: Maybe<User>;
  verifyMagicLink?: Maybe<User>;
};


export type MutationAcknowledgeAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationBillingPortalUrlArgs = {
  email: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationCheckoutArgs = {
  countryCode: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationCreateAlertRuleArgs = {
  notifyEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  orgId: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  ruleType: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
  windowMinutes: Scalars['Int']['input'];
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateProjectArgs = {
  name: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
};


export type MutationCreateVerificationArgs = {
  email: Scalars['String']['input'];
};


export type MutationDeleteAlertRuleArgs = {
  id: Scalars['ID']['input'];
  orgId: Scalars['String']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTestCaseArgs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationEnsurePersonalOrganizationArgs = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationInsertRevocationArgs = {
  jti?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationProcessBillingWebhookArgs = {
  payload: Scalars['JSON']['input'];
};


export type MutationProcessExecutionMetricsArgs = {
  record: Scalars['JSON']['input'];
};


export type MutationRemoveOrgMemberArgs = {
  orgId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveProjectMemberArgs = {
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRotateProjectSecretArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetEdgeSyncConfigArgs = {
  config: Scalars['JSON']['input'];
};


export type MutationSetEdgeTlsArgs = {
  certPem: Scalars['String']['input'];
  keyPem: Scalars['String']['input'];
};


export type MutationSoftDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationUpdateOrgMemberRoleArgs = {
  orgId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectArgs = {
  agentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectAgentUrlArgs = {
  agentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTestCaseArgs = {
  id: Scalars['ID']['input'];
  lastStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};


export type MutationUpdateTestCaseStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpsertOrgMemberArgs = {
  invitedBy: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpsertProjectMemberArgs = {
  addedBy: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpsertTestCaseArgs = {
  input: UpsertTestCaseInput;
  projectId: Scalars['String']['input'];
};


export type MutationUpsertUserArgs = {
  email: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerAccountId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyMagicLinkArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type OrgMember = {
  __typename?: 'OrgMember';
  id?: Maybe<Scalars['ID']['output']>;
  invitedBy?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['Date']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type OrgMembership = {
  __typename?: 'OrgMembership';
  joinedAt?: Maybe<Scalars['Date']['output']>;
  org?: Maybe<Organization>;
  role?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  createdAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type Project = {
  __typename?: 'Project';
  agentUrl?: Maybe<Scalars['String']['output']>;
  executions?: Maybe<Array<Execution>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  stats?: Maybe<StatsBoundary>;
};


export type ProjectExecutionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  range: TimeRange;
};


export type ProjectStatsArgs = {
  range: TimeRange;
};

export type ProjectMember = {
  __typename?: 'ProjectMember';
  addedAt?: Maybe<Scalars['Date']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  alertEvents?: Maybe<Array<AlertEvent>>;
  alertRules?: Maybe<Array<AlertRule>>;
  bootstrapProjects?: Maybe<BootstrapResult>;
  globalStats?: Maybe<GlobalStats>;
  listRevocations?: Maybe<RevocationsResult>;
  orgMembers?: Maybe<Array<OrgMember>>;
  orgMemberships?: Maybe<Array<OrgMembership>>;
  organization?: Maybe<Organization>;
  organizations?: Maybe<Array<Organization>>;
  project?: Maybe<Project>;
  projectMembers?: Maybe<Array<ProjectMember>>;
  projectToken?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<Array<Project>>;
  streamProjectIds?: Maybe<Array<Scalars['String']['output']>>;
  subscription?: Maybe<SubscriptionResult>;
  testCases?: Maybe<Array<TestCase>>;
  userByEmail?: Maybe<User>;
  userProfile?: Maybe<User>;
  usersByIds?: Maybe<Array<User>>;
};


export type QueryAlertEventsArgs = {
  projectIds: Array<Scalars['String']['input']>;
};


export type QueryAlertRulesArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryListRevocationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrgMembersArgs = {
  orgId: Scalars['String']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectMembersArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryProjectTokenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTestCasesArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUsersByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};

export type RevocationsResult = {
  __typename?: 'RevocationsResult';
  nextCursor?: Maybe<Scalars['String']['output']>;
  revokedProjects?: Maybe<Scalars['JSON']['output']>;
  revokedTokens?: Maybe<Array<Scalars['String']['output']>>;
};

export type SetEdgeSyncConfigResult = {
  __typename?: 'SetEdgeSyncConfigResult';
  ok?: Maybe<Scalars['Boolean']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
};

export type SetEdgeTlsResult = {
  __typename?: 'SetEdgeTlsResult';
  ok?: Maybe<Scalars['Boolean']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
};

export type StatsBoundary = {
  __typename?: 'StatsBoundary';
  bucketEnd?: Maybe<Scalars['Float']['output']>;
  errors?: Maybe<Scalars['Int']['output']>;
  isPartial?: Maybe<Scalars['Boolean']['output']>;
  latencyBuckets?: Maybe<Scalars['JSON']['output']>;
  success?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionResult = {
  __typename?: 'SubscriptionResult';
  dodoSubscriptionId?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TestCase = {
  __typename?: 'TestCase';
  entry?: Maybe<Scalars['String']['output']>;
  executionId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastRunAt?: Maybe<Scalars['Date']['output']>;
  lastStatus?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
};

export enum TimeRange {
  Last_1Hour = 'LAST_1_HOUR',
  Last_5Min = 'LAST_5_MIN',
  Last_24Hours = 'LAST_24_HOURS',
  Last_30Days = 'LAST_30_DAYS'
}

export type UpsertTestCaseInput = {
  entry?: InputMaybe<Scalars['String']['input']>;
  executionId: Scalars['String']['input'];
  inputHash?: InputMaybe<Scalars['String']['input']>;
  inputSnapshot?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outputHash?: InputMaybe<Scalars['String']['input']>;
  outputSnapshot?: InputMaybe<Scalars['JSON']['input']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primaryOrganization?: Maybe<Organization>;
};

export type Verification = {
  __typename?: 'Verification';
  id?: Maybe<Scalars['ID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type WebhookResult = {
  __typename?: 'WebhookResult';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ListOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrganizationsQuery = { __typename?: 'Query', organizations?: Array<{ __typename?: 'Organization', id?: string | null, name?: string | null }> | null };

export type GetOrgMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgMembershipsQuery = { __typename?: 'Query', orgMemberships?: Array<{ __typename?: 'OrgMembership', role?: string | null, joinedAt?: string | null, org?: { __typename?: 'Organization', id?: string | null, name?: string | null, slug?: string | null, createdAt?: string | null } | null }> | null };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id?: string | null, name?: string | null, slug?: string | null, createdAt?: string | null } | null };

export type GetOrgMembersQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type GetOrgMembersQuery = { __typename?: 'Query', orgMembers?: Array<{ __typename?: 'OrgMember', id?: string | null, orgId?: string | null, userId?: string | null, role?: string | null, invitedBy?: string | null, joinedAt?: string | null }> | null };

export type GetProjectMembersQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectMembersQuery = { __typename?: 'Query', projectMembers?: Array<{ __typename?: 'ProjectMember', id?: string | null, projectId?: string | null, userId?: string | null, role?: string | null, addedBy?: string | null, addedAt?: string | null }> | null };

export type GetProjectTokenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectTokenQuery = { __typename?: 'Query', projectToken?: string | null };

export type GetSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { __typename?: 'Query', subscription?: { __typename?: 'SubscriptionResult', plan?: string | null, status?: string | null, dodoSubscriptionId?: string | null } | null };

export type GetGlobalStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalStatsQuery = { __typename?: 'Query', globalStats?: { __typename?: 'GlobalStats', activeProjects?: number | null, totalEdges?: number | null, activeEdges?: number | null, degradedEdges?: number | null, deadEdges?: number | null } | null };

export type ListProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListProjectsQuery = { __typename?: 'Query', projects?: Array<{ __typename?: 'Project', id?: string | null, name?: string | null, agentUrl?: string | null, organization?: { __typename?: 'Organization', id?: string | null } | null }> | null };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProjectQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id?: string | null, name?: string | null, agentUrl?: string | null, organization?: { __typename?: 'Organization', id?: string | null } | null, stats?: { __typename?: 'StatsBoundary', total?: number | null, success?: number | null, errors?: number | null, latencyBuckets?: Record<string, unknown> | null } | null } | null };

export type GetAlertEventsQueryVariables = Exact<{
  projectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAlertEventsQuery = { __typename?: 'Query', alertEvents?: Array<{ __typename?: 'AlertEvent', id?: string | null, projectId?: string | null, ruleId?: string | null, errorType?: string | null, metricValue?: number | null, threshold?: number | null, firedAt?: string | null, acknowledgedAt?: string | null }> | null };

export type GetAlertRulesQueryVariables = Exact<{
  orgId: Scalars['String']['input'];
}>;


export type GetAlertRulesQuery = { __typename?: 'Query', alertRules?: Array<{ __typename?: 'AlertRule', id?: string | null, orgId?: string | null, projectId?: string | null, ruleType?: string | null, threshold?: number | null, windowMinutes?: number | null, enabled?: number | null }> | null };

export type GetTestCasesQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetTestCasesQuery = { __typename?: 'Query', testCases?: Array<{ __typename?: 'TestCase', id?: string | null, projectId?: string | null, executionId?: string | null, name?: string | null, entry?: string | null, lastStatus?: string | null, lastRunAt?: string | null }> | null };

export type AcknowledgeAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcknowledgeAlertMutation = { __typename?: 'Mutation', acknowledgeAlert?: { __typename?: 'AlertEvent', id?: string | null, acknowledgedAt?: string | null } | null };

export type CreateAlertRuleMutationVariables = Exact<{
  orgId: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  ruleType: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
  windowMinutes: Scalars['Int']['input'];
  notifyEmails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateAlertRuleMutation = { __typename?: 'Mutation', createAlertRule?: { __typename?: 'AlertRule', id?: string | null } | null };

export type DeleteAlertRuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  orgId: Scalars['String']['input'];
}>;


export type DeleteAlertRuleMutation = { __typename?: 'Mutation', deleteAlertRule?: boolean | null };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserByEmailQuery = { __typename?: 'Query', userByEmail?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null } | null };

export type GetUsersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetUsersByIdsQuery = { __typename?: 'Query', usersByIds?: Array<{ __typename?: 'User', id?: string | null, email?: string | null, name?: string | null }> | null };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null, image?: string | null, primaryOrganization?: { __typename?: 'Organization', id?: string | null, name?: string | null, slug?: string | null, createdAt?: string | null } | null } | null };

export type UpsertUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerAccountId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertUserMutation = { __typename?: 'Mutation', upsertUser?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null, image?: string | null } | null };

export type VerifyMagicLinkMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type VerifyMagicLinkMutation = { __typename?: 'Mutation', verifyMagicLink?: { __typename?: 'User', id?: string | null, email?: string | null, name?: string | null, image?: string | null } | null };

export type InitiateVerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type InitiateVerificationMutation = { __typename?: 'Mutation', createVerification?: { __typename?: 'Verification', id?: string | null, value?: string | null } | null };

export type CreateProjectMutationVariables = Exact<{
  name: Scalars['String']['input'];
  orgId: Scalars['String']['input'];
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject?: { __typename?: 'Project', id?: string | null, name?: string | null } | null };

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  agentUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject?: { __typename?: 'Project', id?: string | null, name?: string | null, agentUrl?: string | null } | null };

export type RotateSecretMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RotateSecretMutation = { __typename?: 'Mutation', rotateProjectSecret?: { __typename?: 'Project', id?: string | null } | null };

export type CreateOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'Organization', id?: string | null, name?: string | null, slug?: string | null, createdAt?: string | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'Organization', id?: string | null, name?: string | null, slug?: string | null, createdAt?: string | null } | null };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: boolean | null };

export type UpsertOrgMemberMutationVariables = Exact<{
  orgId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  invitedBy: Scalars['String']['input'];
}>;


export type UpsertOrgMemberMutation = { __typename?: 'Mutation', upsertOrgMember?: { __typename?: 'OrgMember', id?: string | null, orgId?: string | null, userId?: string | null, role?: string | null, invitedBy?: string | null, joinedAt?: string | null } | null };

export type UpdateOrgMemberRoleMutationVariables = Exact<{
  orgId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateOrgMemberRoleMutation = { __typename?: 'Mutation', updateOrgMemberRole?: { __typename?: 'OrgMember', id?: string | null, orgId?: string | null, userId?: string | null, role?: string | null } | null };

export type RemoveOrgMemberMutationVariables = Exact<{
  orgId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type RemoveOrgMemberMutation = { __typename?: 'Mutation', removeOrgMember?: boolean | null };

export type SoftDeleteProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SoftDeleteProjectMutation = { __typename?: 'Mutation', softDeleteProject?: boolean | null };

export type UpdateProjectAgentUrlMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  agentUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectAgentUrlMutation = { __typename?: 'Mutation', updateProjectAgentUrl?: { __typename?: 'Project', id?: string | null, agentUrl?: string | null } | null };

export type InsertRevocationMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  jti?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertRevocationMutation = { __typename?: 'Mutation', insertRevocation?: boolean | null };

export type UpsertProjectMemberMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  addedBy: Scalars['String']['input'];
}>;


export type UpsertProjectMemberMutation = { __typename?: 'Mutation', upsertProjectMember?: { __typename?: 'ProjectMember', id?: string | null, projectId?: string | null, userId?: string | null, role?: string | null, addedBy?: string | null, addedAt?: string | null } | null };

export type RemoveProjectMemberMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type RemoveProjectMemberMutation = { __typename?: 'Mutation', removeProjectMember?: boolean | null };

export type UpsertTestCaseMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  input: UpsertTestCaseInput;
}>;


export type UpsertTestCaseMutation = { __typename?: 'Mutation', upsertTestCase?: { __typename?: 'TestCase', id?: string | null, projectId?: string | null, executionId?: string | null, name?: string | null, entry?: string | null, lastStatus?: string | null, lastRunAt?: string | null } | null };

export type UpdateTestCaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  lastStatus?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTestCaseMutation = { __typename?: 'Mutation', updateTestCase?: { __typename?: 'TestCase', id?: string | null, projectId?: string | null, executionId?: string | null, name?: string | null, entry?: string | null, lastStatus?: string | null, lastRunAt?: string | null } | null };

export type DeleteTestCaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  projectId: Scalars['String']['input'];
}>;


export type DeleteTestCaseMutation = { __typename?: 'Mutation', deleteTestCase?: boolean | null };

export type UpdateTestCaseStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateTestCaseStatusMutation = { __typename?: 'Mutation', updateTestCaseStatus?: boolean | null };

export type SyncSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type SyncSubscriptionMutation = { __typename?: 'Mutation', syncSubscription?: { __typename?: 'SubscriptionResult', plan?: string | null, status?: string | null, dodoSubscriptionId?: string | null } | null };

export type CheckoutMutationVariables = Exact<{
  planId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckoutMutation = { __typename?: 'Mutation', checkout?: { __typename?: 'CheckoutResult', checkoutUrl?: string | null, upgraded?: boolean | null, syncSubId?: string | null } | null };

export type BillingPortalUrlMutationVariables = Exact<{
  email: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
}>;


export type BillingPortalUrlMutation = { __typename?: 'Mutation', billingPortalUrl?: string | null };

export type ProcessExecutionMetricsMutationVariables = Exact<{
  record: Scalars['JSON']['input'];
}>;


export type ProcessExecutionMetricsMutation = { __typename?: 'Mutation', processExecutionMetrics?: { __typename?: 'MetricsResult', evaluated?: number | null, fired?: number | null } | null };


export const ListOrganizationsDocument = /*#__PURE__*/ gql`
    query ListOrganizations {
  organizations {
    id
    name
  }
}
    `;
export const GetOrgMembershipsDocument = /*#__PURE__*/ gql`
    query GetOrgMemberships {
  orgMemberships {
    org {
      id
      name
      slug
      createdAt
    }
    role
    joinedAt
  }
}
    `;
export const GetOrganizationDocument = /*#__PURE__*/ gql`
    query GetOrganization($id: ID!) {
  organization(id: $id) {
    id
    name
    slug
    createdAt
  }
}
    `;
export const GetOrgMembersDocument = /*#__PURE__*/ gql`
    query GetOrgMembers($orgId: String!) {
  orgMembers(orgId: $orgId) {
    id
    orgId
    userId
    role
    invitedBy
    joinedAt
  }
}
    `;
export const GetProjectMembersDocument = /*#__PURE__*/ gql`
    query GetProjectMembers($projectId: String!) {
  projectMembers(projectId: $projectId) {
    id
    projectId
    userId
    role
    addedBy
    addedAt
  }
}
    `;
export const GetProjectTokenDocument = /*#__PURE__*/ gql`
    query GetProjectToken($id: ID!) {
  projectToken(id: $id)
}
    `;
export const GetSubscriptionDocument = /*#__PURE__*/ gql`
    query GetSubscription {
  subscription {
    plan
    status
    dodoSubscriptionId
  }
}
    `;
export const GetGlobalStatsDocument = /*#__PURE__*/ gql`
    query GetGlobalStats {
  globalStats {
    activeProjects
    totalEdges
    activeEdges
    degradedEdges
    deadEdges
  }
}
    `;
export const ListProjectsDocument = /*#__PURE__*/ gql`
    query ListProjects {
  projects {
    id
    name
    agentUrl
    organization {
      id
    }
  }
}
    `;
export const GetProjectDocument = /*#__PURE__*/ gql`
    query GetProject($id: ID!) {
  project(id: $id) {
    id
    name
    agentUrl
    organization {
      id
    }
    stats(range: LAST_5_MIN) {
      total
      success
      errors
      latencyBuckets
    }
  }
}
    `;
export const GetAlertEventsDocument = /*#__PURE__*/ gql`
    query GetAlertEvents($projectIds: [String!]!) {
  alertEvents(projectIds: $projectIds) {
    id
    projectId
    ruleId
    errorType
    metricValue
    threshold
    firedAt
    acknowledgedAt
  }
}
    `;
export const GetAlertRulesDocument = /*#__PURE__*/ gql`
    query GetAlertRules($orgId: String!) {
  alertRules(orgId: $orgId) {
    id
    orgId
    projectId
    ruleType
    threshold
    windowMinutes
    enabled
  }
}
    `;
export const GetTestCasesDocument = /*#__PURE__*/ gql`
    query GetTestCases($projectId: String!) {
  testCases(projectId: $projectId) {
    id
    projectId
    executionId
    name
    entry
    lastStatus
    lastRunAt
  }
}
    `;
export const AcknowledgeAlertDocument = /*#__PURE__*/ gql`
    mutation AcknowledgeAlert($id: ID!) {
  acknowledgeAlert(id: $id) {
    id
    acknowledgedAt
  }
}
    `;
export const CreateAlertRuleDocument = /*#__PURE__*/ gql`
    mutation CreateAlertRule($orgId: String!, $projectId: String, $ruleType: String!, $threshold: Float!, $windowMinutes: Int!, $notifyEmails: [String!]) {
  createAlertRule(
    orgId: $orgId
    projectId: $projectId
    ruleType: $ruleType
    threshold: $threshold
    windowMinutes: $windowMinutes
    notifyEmails: $notifyEmails
  ) {
    id
  }
}
    `;
export const DeleteAlertRuleDocument = /*#__PURE__*/ gql`
    mutation DeleteAlertRule($id: ID!, $orgId: String!) {
  deleteAlertRule(id: $id, orgId: $orgId)
}
    `;
export const GetUserByEmailDocument = /*#__PURE__*/ gql`
    query GetUserByEmail($email: String!) {
  userByEmail(email: $email) {
    id
    email
    name
  }
}
    `;
export const GetUsersByIdsDocument = /*#__PURE__*/ gql`
    query GetUsersByIds($ids: [String!]!) {
  usersByIds(ids: $ids) {
    id
    email
    name
  }
}
    `;
export const GetProfileDocument = /*#__PURE__*/ gql`
    query GetProfile {
  userProfile {
    id
    email
    name
    image
    primaryOrganization {
      id
      name
      slug
      createdAt
    }
  }
}
    `;
export const UpsertUserDocument = /*#__PURE__*/ gql`
    mutation UpsertUser($email: String!, $name: String, $image: String, $providerId: String, $providerAccountId: String) {
  upsertUser(
    email: $email
    name: $name
    image: $image
    providerId: $providerId
    providerAccountId: $providerAccountId
  ) {
    id
    email
    name
    image
  }
}
    `;
export const VerifyMagicLinkDocument = /*#__PURE__*/ gql`
    mutation VerifyMagicLink($email: String!, $token: String!) {
  verifyMagicLink(email: $email, token: $token) {
    id
    email
    name
    image
  }
}
    `;
export const InitiateVerificationDocument = /*#__PURE__*/ gql`
    mutation InitiateVerification($email: String!) {
  createVerification(email: $email) {
    id
    value
  }
}
    `;
export const CreateProjectDocument = /*#__PURE__*/ gql`
    mutation CreateProject($name: String!, $orgId: String!) {
  createProject(name: $name, orgId: $orgId) {
    id
    name
  }
}
    `;
export const UpdateProjectDocument = /*#__PURE__*/ gql`
    mutation UpdateProject($id: ID!, $name: String, $agentUrl: String) {
  updateProject(id: $id, name: $name, agentUrl: $agentUrl) {
    id
    name
    agentUrl
  }
}
    `;
export const RotateSecretDocument = /*#__PURE__*/ gql`
    mutation RotateSecret($id: ID!) {
  rotateProjectSecret(id: $id) {
    id
  }
}
    `;
export const CreateOrganizationDocument = /*#__PURE__*/ gql`
    mutation CreateOrganization($name: String!, $slug: String) {
  createOrganization(name: $name, slug: $slug) {
    id
    name
    slug
    createdAt
  }
}
    `;
export const UpdateOrganizationDocument = /*#__PURE__*/ gql`
    mutation UpdateOrganization($id: ID!, $name: String, $slug: String) {
  updateOrganization(id: $id, name: $name, slug: $slug) {
    id
    name
    slug
    createdAt
  }
}
    `;
export const DeleteOrganizationDocument = /*#__PURE__*/ gql`
    mutation DeleteOrganization($id: ID!) {
  deleteOrganization(id: $id)
}
    `;
export const UpsertOrgMemberDocument = /*#__PURE__*/ gql`
    mutation UpsertOrgMember($orgId: String!, $userId: String!, $role: String!, $invitedBy: String!) {
  upsertOrgMember(
    orgId: $orgId
    userId: $userId
    role: $role
    invitedBy: $invitedBy
  ) {
    id
    orgId
    userId
    role
    invitedBy
    joinedAt
  }
}
    `;
export const UpdateOrgMemberRoleDocument = /*#__PURE__*/ gql`
    mutation UpdateOrgMemberRole($orgId: String!, $userId: String!, $role: String!) {
  updateOrgMemberRole(orgId: $orgId, userId: $userId, role: $role) {
    id
    orgId
    userId
    role
  }
}
    `;
export const RemoveOrgMemberDocument = /*#__PURE__*/ gql`
    mutation RemoveOrgMember($orgId: String!, $userId: String!) {
  removeOrgMember(orgId: $orgId, userId: $userId)
}
    `;
export const SoftDeleteProjectDocument = /*#__PURE__*/ gql`
    mutation SoftDeleteProject($id: ID!) {
  softDeleteProject(id: $id)
}
    `;
export const UpdateProjectAgentUrlDocument = /*#__PURE__*/ gql`
    mutation UpdateProjectAgentUrl($id: ID!, $agentUrl: String) {
  updateProjectAgentUrl(id: $id, agentUrl: $agentUrl) {
    id
    agentUrl
  }
}
    `;
export const InsertRevocationDocument = /*#__PURE__*/ gql`
    mutation InsertRevocation($projectId: String!, $type: String!, $jti: String) {
  insertRevocation(projectId: $projectId, type: $type, jti: $jti)
}
    `;
export const UpsertProjectMemberDocument = /*#__PURE__*/ gql`
    mutation UpsertProjectMember($projectId: String!, $userId: String!, $role: String!, $addedBy: String!) {
  upsertProjectMember(
    projectId: $projectId
    userId: $userId
    role: $role
    addedBy: $addedBy
  ) {
    id
    projectId
    userId
    role
    addedBy
    addedAt
  }
}
    `;
export const RemoveProjectMemberDocument = /*#__PURE__*/ gql`
    mutation RemoveProjectMember($projectId: String!, $userId: String!) {
  removeProjectMember(projectId: $projectId, userId: $userId)
}
    `;
export const UpsertTestCaseDocument = /*#__PURE__*/ gql`
    mutation UpsertTestCase($projectId: String!, $input: UpsertTestCaseInput!) {
  upsertTestCase(projectId: $projectId, input: $input) {
    id
    projectId
    executionId
    name
    entry
    lastStatus
    lastRunAt
  }
}
    `;
export const UpdateTestCaseDocument = /*#__PURE__*/ gql`
    mutation UpdateTestCase($id: ID!, $projectId: String!, $name: String, $lastStatus: String) {
  updateTestCase(
    id: $id
    projectId: $projectId
    name: $name
    lastStatus: $lastStatus
  ) {
    id
    projectId
    executionId
    name
    entry
    lastStatus
    lastRunAt
  }
}
    `;
export const DeleteTestCaseDocument = /*#__PURE__*/ gql`
    mutation DeleteTestCase($id: ID!, $projectId: String!) {
  deleteTestCase(id: $id, projectId: $projectId)
}
    `;
export const UpdateTestCaseStatusDocument = /*#__PURE__*/ gql`
    mutation UpdateTestCaseStatus($id: ID!, $status: String!) {
  updateTestCaseStatus(id: $id, status: $status)
}
    `;
export const SyncSubscriptionDocument = /*#__PURE__*/ gql`
    mutation SyncSubscription($subscriptionId: String!) {
  syncSubscription(subscriptionId: $subscriptionId) {
    plan
    status
    dodoSubscriptionId
  }
}
    `;
export const CheckoutDocument = /*#__PURE__*/ gql`
    mutation Checkout($planId: String!, $productId: String!, $returnUrl: String!, $countryCode: String!, $name: String) {
  checkout(
    planId: $planId
    productId: $productId
    returnUrl: $returnUrl
    countryCode: $countryCode
    name: $name
  ) {
    checkoutUrl
    upgraded
    syncSubId
  }
}
    `;
export const BillingPortalUrlDocument = /*#__PURE__*/ gql`
    mutation BillingPortalUrl($email: String!, $returnUrl: String!) {
  billingPortalUrl(email: $email, returnUrl: $returnUrl)
}
    `;
export const ProcessExecutionMetricsDocument = /*#__PURE__*/ gql`
    mutation ProcessExecutionMetrics($record: JSON!) {
  processExecutionMetrics(record: $record) {
    evaluated
    fired
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    ListOrganizations(variables?: ListOrganizationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ListOrganizationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListOrganizationsQuery>({ document: ListOrganizationsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ListOrganizations', 'query', variables);
    },
    GetOrgMemberships(variables?: GetOrgMembershipsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetOrgMembershipsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrgMembershipsQuery>({ document: GetOrgMembershipsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetOrgMemberships', 'query', variables);
    },
    GetOrganization(variables: GetOrganizationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetOrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrganizationQuery>({ document: GetOrganizationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetOrganization', 'query', variables);
    },
    GetOrgMembers(variables: GetOrgMembersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetOrgMembersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrgMembersQuery>({ document: GetOrgMembersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetOrgMembers', 'query', variables);
    },
    GetProjectMembers(variables: GetProjectMembersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProjectMembersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectMembersQuery>({ document: GetProjectMembersDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetProjectMembers', 'query', variables);
    },
    GetProjectToken(variables: GetProjectTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProjectTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectTokenQuery>({ document: GetProjectTokenDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetProjectToken', 'query', variables);
    },
    GetSubscription(variables?: GetSubscriptionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetSubscriptionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSubscriptionQuery>({ document: GetSubscriptionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetSubscription', 'query', variables);
    },
    GetGlobalStats(variables?: GetGlobalStatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetGlobalStatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetGlobalStatsQuery>({ document: GetGlobalStatsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetGlobalStats', 'query', variables);
    },
    ListProjects(variables?: ListProjectsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ListProjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ListProjectsQuery>({ document: ListProjectsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ListProjects', 'query', variables);
    },
    GetProject(variables: GetProjectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProjectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectQuery>({ document: GetProjectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetProject', 'query', variables);
    },
    GetAlertEvents(variables: GetAlertEventsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetAlertEventsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAlertEventsQuery>({ document: GetAlertEventsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetAlertEvents', 'query', variables);
    },
    GetAlertRules(variables: GetAlertRulesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetAlertRulesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAlertRulesQuery>({ document: GetAlertRulesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetAlertRules', 'query', variables);
    },
    GetTestCases(variables: GetTestCasesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetTestCasesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTestCasesQuery>({ document: GetTestCasesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetTestCases', 'query', variables);
    },
    AcknowledgeAlert(variables: AcknowledgeAlertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AcknowledgeAlertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AcknowledgeAlertMutation>({ document: AcknowledgeAlertDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AcknowledgeAlert', 'mutation', variables);
    },
    CreateAlertRule(variables: CreateAlertRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateAlertRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAlertRuleMutation>({ document: CreateAlertRuleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateAlertRule', 'mutation', variables);
    },
    DeleteAlertRule(variables: DeleteAlertRuleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteAlertRuleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteAlertRuleMutation>({ document: DeleteAlertRuleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteAlertRule', 'mutation', variables);
    },
    GetUserByEmail(variables: GetUserByEmailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUserByEmailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserByEmailQuery>({ document: GetUserByEmailDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetUserByEmail', 'query', variables);
    },
    GetUsersByIds(variables: GetUsersByIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetUsersByIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersByIdsQuery>({ document: GetUsersByIdsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetUsersByIds', 'query', variables);
    },
    GetProfile(variables?: GetProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<GetProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProfileQuery>({ document: GetProfileDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'GetProfile', 'query', variables);
    },
    UpsertUser(variables: UpsertUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpsertUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertUserMutation>({ document: UpsertUserDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpsertUser', 'mutation', variables);
    },
    VerifyMagicLink(variables: VerifyMagicLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<VerifyMagicLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifyMagicLinkMutation>({ document: VerifyMagicLinkDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'VerifyMagicLink', 'mutation', variables);
    },
    InitiateVerification(variables: InitiateVerificationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InitiateVerificationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InitiateVerificationMutation>({ document: InitiateVerificationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'InitiateVerification', 'mutation', variables);
    },
    CreateProject(variables: CreateProjectMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateProjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateProjectMutation>({ document: CreateProjectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateProject', 'mutation', variables);
    },
    UpdateProject(variables: UpdateProjectMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateProjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProjectMutation>({ document: UpdateProjectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateProject', 'mutation', variables);
    },
    RotateSecret(variables: RotateSecretMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RotateSecretMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RotateSecretMutation>({ document: RotateSecretDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RotateSecret', 'mutation', variables);
    },
    CreateOrganization(variables: CreateOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CreateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOrganizationMutation>({ document: CreateOrganizationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateOrganization', 'mutation', variables);
    },
    UpdateOrganization(variables: UpdateOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrganizationMutation>({ document: UpdateOrganizationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateOrganization', 'mutation', variables);
    },
    DeleteOrganization(variables: DeleteOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOrganizationMutation>({ document: DeleteOrganizationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteOrganization', 'mutation', variables);
    },
    UpsertOrgMember(variables: UpsertOrgMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpsertOrgMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertOrgMemberMutation>({ document: UpsertOrgMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpsertOrgMember', 'mutation', variables);
    },
    UpdateOrgMemberRole(variables: UpdateOrgMemberRoleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateOrgMemberRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOrgMemberRoleMutation>({ document: UpdateOrgMemberRoleDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateOrgMemberRole', 'mutation', variables);
    },
    RemoveOrgMember(variables: RemoveOrgMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveOrgMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveOrgMemberMutation>({ document: RemoveOrgMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveOrgMember', 'mutation', variables);
    },
    SoftDeleteProject(variables: SoftDeleteProjectMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SoftDeleteProjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SoftDeleteProjectMutation>({ document: SoftDeleteProjectDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SoftDeleteProject', 'mutation', variables);
    },
    UpdateProjectAgentUrl(variables: UpdateProjectAgentUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateProjectAgentUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProjectAgentUrlMutation>({ document: UpdateProjectAgentUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateProjectAgentUrl', 'mutation', variables);
    },
    InsertRevocation(variables: InsertRevocationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<InsertRevocationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertRevocationMutation>({ document: InsertRevocationDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'InsertRevocation', 'mutation', variables);
    },
    UpsertProjectMember(variables: UpsertProjectMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpsertProjectMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertProjectMemberMutation>({ document: UpsertProjectMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpsertProjectMember', 'mutation', variables);
    },
    RemoveProjectMember(variables: RemoveProjectMemberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<RemoveProjectMemberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveProjectMemberMutation>({ document: RemoveProjectMemberDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveProjectMember', 'mutation', variables);
    },
    UpsertTestCase(variables: UpsertTestCaseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpsertTestCaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertTestCaseMutation>({ document: UpsertTestCaseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpsertTestCase', 'mutation', variables);
    },
    UpdateTestCase(variables: UpdateTestCaseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateTestCaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTestCaseMutation>({ document: UpdateTestCaseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateTestCase', 'mutation', variables);
    },
    DeleteTestCase(variables: DeleteTestCaseMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteTestCaseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTestCaseMutation>({ document: DeleteTestCaseDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteTestCase', 'mutation', variables);
    },
    UpdateTestCaseStatus(variables: UpdateTestCaseStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<UpdateTestCaseStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateTestCaseStatusMutation>({ document: UpdateTestCaseStatusDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateTestCaseStatus', 'mutation', variables);
    },
    SyncSubscription(variables: SyncSubscriptionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SyncSubscriptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SyncSubscriptionMutation>({ document: SyncSubscriptionDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SyncSubscription', 'mutation', variables);
    },
    Checkout(variables: CheckoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<CheckoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckoutMutation>({ document: CheckoutDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Checkout', 'mutation', variables);
    },
    BillingPortalUrl(variables: BillingPortalUrlMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<BillingPortalUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BillingPortalUrlMutation>({ document: BillingPortalUrlDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'BillingPortalUrl', 'mutation', variables);
    },
    ProcessExecutionMetrics(variables: ProcessExecutionMetricsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ProcessExecutionMetricsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProcessExecutionMetricsMutation>({ document: ProcessExecutionMetricsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ProcessExecutionMetrics', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;